<template>
  <div v-if="birthday(billingDate)" class="pt-1">
    <v-chip :color="chipColor"> Payment {{ billingText }} </v-chip>
  </div>
</template>

<script>
import BirthdayMixin from "@/components/shared/mixins/BirthdayMixin";

export default {
  name: "BillingChip",
  props: {
    billingDate: {
      type: String,
      required: false,
    },
  },
  mixins: [BirthdayMixin],
  computed: {
    chipColor() {
      let tense = this.birthday(this.billingDate).tense;
      let color = "#E9EAEA";

      switch (tense) {
        case "Today":
          color = "#D0F6F2";
          break;
        case "Past":
          color = "#E9EAEA";
          break;
        case "Future":
          color = "#15b775";
          break;
      }

      return color;
    },
    billingText() {
      return this.birthday(this.billingDate).text;
    },
  },
};
</script>
